import { defineMessages } from 'react-intl-next';

type i18nType = {
	defaultMessage: string;
	description: string;
	id: string;
};

type FilterLabelsType = Record<string, i18nType>;

export const i18n: FilterLabelsType = defineMessages({
	title: {
		id: 'dynamic-cards-search-page.filters.dropdown.title',
		defaultMessage: 'Filter',
		description: 'Text for the filter button shown in search page where opens the filter dropdown to apply filters to the search results',
	},
	clearAll: {
		id: 'dynamic-cards-search-page.filters.dropdown.clear-all',
		defaultMessage: 'Clear all',
		description: 'Label for clearing all filters in the dropdown',
	},
});
